var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaySoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4208 5.27101L1.77773 0.161271C1.07548 -0.253696 0 0.148994 0 1.17536V11.3924C0 12.3132 0.999358 12.8681 1.77773 12.4065L10.4208 7.29919C11.1918 6.84494 11.1943 5.72527 10.4208 5.27101Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaySoundIcon);
export default __webpack_public_path__ + "static/media/play-sound-icon.0bb378e83f3f0459b73c8cb171d8d3cf.svg";
export { ForwardRef as ReactComponent };